module.exports = __webpack_public_path__ + "static/3-2cd73147ca3b11b33a2c53107929ebc4.jpg";